export const MOBILE_DRAWER_STYLE: React.CSSProperties = {
  background:
    'linear-gradient( 180deg, rgba(0, 0, 0, 0.9) 0%, rgba(87, 47, 102, 0.9) 50%, rgba(29, 21, 21, 0.9) 100%)',
  padding: '15px 13px 0 13px',
  borderTopRightRadius: '16px',
  borderTopLeftRadius: '16px',
}

export const MOBILE_DRAWER_HEIGHT = '85%'

export const MOBILE_PAGE_PADDING = '6px'

// Z-index 常量
export const Z_INDEX_CHARACTER_BACKGROUND_MODAL = 9999
export const Z_INDEX_CHAT_SETTING_DRAWER =
  Z_INDEX_CHARACTER_BACKGROUND_MODAL + 1
